import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const SessionExpiryModal = ({ onClose }) => {
  const { t } = useLanguage();

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6 animate-fadeIn">
        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
            <svg
              width="32"
              height="32"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="text-yellow-600"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-center text-gray-900 mb-2">
          {t('session.expired.title')}
        </h2>

        {/* Message */}
        <p className="text-center text-gray-600 mb-4">
          {t('session.expired.message')}
        </p>

        {/* Redirecting notice */}
        <p className="text-center text-sm text-gray-500 animate-pulse">
          {t('session.expired.redirecting')}
        </p>
      </div>
    </div>
  );
};

export default SessionExpiryModal;
